import { useState } from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Phone, Menu, X, CircleCheck as CheckCircle2 } from 'lucide-react';
import { Sheet, SheetContent, SheetHeader, SheetTitle, SheetTrigger } from "@/components/ui/sheet";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { WvcLogo } from '@/integrations/wordpress/WvcLogo';
function DesktopMenu() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="hidden lg:flex items-center gap-4">
        {[1, 2, 3, 4].map(i => <div key={i} data-index={i} className="h-4 w-16 bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  return <NavigationMenu className="hidden lg:flex">
      <NavigationMenuList className="gap-2">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id || i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="px-4 py-2 text-sm font-semibold uppercase tracking-wider text-foreground/80 hover:text-secondary transition-colors">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
function MobileMenuContent() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-4 mt-8">
        {[1, 2, 3, 4, 5].map(i => <div key={i} data-index={i} className="h-8 w-full bg-muted animate-pulse rounded-md" />)}
      </div>;
  }
  return <div className="flex flex-col gap-2 mt-8">
      {menuItems.map((item, i) => <Link key={item.id || i} to={item.href || "#"} className="text-lg font-bold uppercase tracking-tight py-3 border-b border-border hover:text-secondary transition-colors">
          {item.label}
        </Link>)}
      <Link to="tel:3368850698" className="mt-6 flex items-center justify-center gap-2 bg-secondary text-secondary-foreground px-6 py-4 rounded-lg font-bold uppercase tracking-widest">
        <Phone className="size-5" />
        (336) 885-0698
      </Link>
    </div>;
}
export default function Header() {
  return <header id="header" className="w-full sticky top-0 z-50 bg-background/95 backdrop-blur-md border-b border-border shadow-sm">
      
      {}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-24 lg:h-32">
          <div className="hidden lg:flex items-center justify-between w-full">
            <Link to="/" className="flex-shrink-0">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/fabco Logos.png" alt="FABCO Logo" className="h-24 w-auto" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/fabco Logos.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1695754/img/fabco Logos.png-wvc-sizes" loading="lazy" />
            </Link>
            <div className="flex justify-end">
              <MenuProvider menu_id="16">
                <DesktopMenu />
              </MenuProvider>
            </div>
          </div>

          <div className="lg:hidden flex items-center justify-between w-full">
            <Link to="/">
              <WvcLogo className="h-10 w-auto" />
            </Link>
            <Sheet>
              <SheetTrigger asChild>
                <button className="p-2 text-foreground hover:text-secondary transition-colors" aria-label="Open Menu">
                  <Menu className="size-8" />
                </button>
              </SheetTrigger>
              <SheetContent side="right" className="w-[300px] sm:w-[400px]">
                <SheetHeader className="text-left border-b border-border pb-4">
                  <SheetTitle>
                    <Link to="/" className="block mb-2">
                      <WvcLogo className="h-12 w-auto" />
                    </Link>
                  </SheetTitle>
                </SheetHeader>
                <MenuProvider menu_id="16">
                  <MobileMenuContent />
                </MenuProvider>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>

      {}
      <div className="bg-primary text-primary-foreground py-8">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center gap-4">
          <Link to="/">
            <WvcLogo className="h-16 lg:h-24 w-auto" />
          </Link>
          <div className="max-w-3xl">
            <p className="text-sm sm:text-base font-bold uppercase tracking-wider leading-tight mb-2">
              FABCO Industrial Construction is an industrial mechanical, millwright, rigging, fabrication, process piping and general construction firm with a strong reputation for delivering quality installations.
            </p>
            <p className="text-[10px] sm:text-xs font-bold uppercase tracking-[0.2em] text-secondary italic">
              ISN Approved Company & OSHA Certified Professionals
            </p>
          </div>
        </div>
      </div>

      {}
      <div className="bg-secondary text-secondary-foreground py-4">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row justify-between items-center gap-2 text-[10px] sm:text-xs font-bold uppercase tracking-[0.2em]">
          <div className="flex items-center gap-4">
            <span className="flex items-center gap-1.5">
              <CheckCircle2 className="size-3 text-blue-600" />
              Industrial Construction
            </span>
            <span className="flex items-center gap-1.5">
              <CheckCircle2 className="size-3 text-blue-600" />
              Quality Installations
            </span>
          </div>
          <div className="flex items-center gap-4">
            <Link to="tel:3368850698" className="hover:text-white transition-colors flex items-center gap-1.5">
              <Phone className="size-3" />
              (336) 885-0698
            </Link>
          </div>
        </div>
      </div>

    </header>;
}